import useModals from 'src/Hooks/useModals'
import { Button } from '@mui/material'
import { ErrorBanner } from 'src/Libs/installation-details/components'
import { InfoText } from '@e3dc-react/shell/Elements/InfoText'
import { J2Caution } from '@e3dc-react/icons'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface Props {
  hasQntmIpin?: boolean
  onSave: () => void
  onCancel: () => void
}

export const useQntmInviteDialog = (): ((props: Props) => void) => {
  const { openConfirmationModal } = useModals()
  const { t } = useCustomTranslation()

  return ({ hasQntmIpin = false, onSave, onCancel }: Props) =>
    openConfirmationModal({
      title: hasQntmIpin ? t('service-dashboard.users.qntm-ipin-confirmation.title') : t('service-dashboard.users.qntm-ipin-warning.title'),
      text: t('service-dashboard.users.qntm-ipin-warning.question'),
      onConfirm: onClose => {
        onCancel()
        onClose()
      },
      onCancel: onClose => {
        onSave()
        onClose()
      },
      showChildrenOnTop: true,
      buttonText: [t('common.yes'), t('common.no')],
      renderAdditionalButtonContent: onClose => (
        <Button onClick={onClose} color={'inherit'}>
          {t('common.cancel')}
        </Button>
      ),
      children: (
        <ErrorBanner visible={!hasQntmIpin} sx={{ mb: 4 }}>
          <InfoText icon={<J2Caution color={'error'} />} value={t('service-dashboard.users.qntm-ipin-warning.text')} />
        </ErrorBanner>
      ),
    })
}
